export enum PaymentFlow {
  NewSub = 'NEW_SUB',
  NewSubExistingCustomer = 'NEW_SUB_EXISTING_CUSTOMER',
  UpdateSubExpired = 'UPDATE_SUB_EXPIRED',
  UpdatePaymentInfo = 'UPDATE_PAYMENT_INFO',
  CheckOut = 'CHECK_OUT',
  CheckOutExistingCustomer = 'CHECK_OUT_EXISTING_CUSTOMER'
}
